export default [
  {
    text: "대시보드",
    path: "/Home",
    icon: "fa fa-home text-primary",
  },
  {
    text: "구매",
    icon: "fa fa-level-down text-primary",
    items: [
      // { text: "테스트", path: "/Buyer/Test/" },
      { text: "구매요청서", path: "/Buyer/Requisition/" },
      { text: "견적의뢰서", path: "/Buyer/Rfq/" },
      { text: "견적서 확인", path: "/Buyer/QuotationBox/" },
      { text: "발주서", path: "/Buyer/Order/" },
      { text: "매입", path: "/Buyer/Purchase/" },
      { text: "전자계산서 조회", path: "/Buyer/PurchaseTax/", disabled: true },
    ],
  },

  {
    text: "판매",
    icon: "fa fa-level-up text-primary",
    items: [
      { text: "견적의뢰서 확인", path: "/Supplier/RfqBox/" },
      { text: "견적서", path: "/Supplier/Quotation/" },
      { text: "견적서(STOMPLUS)", path: "/Supplier/Quotation4STOM/" },
      { text: "발주서 확인", path: "/Supplier/OrderAck/" },
      { text: "매출", path: "/Supplier/Sales/" },
      { text: "전자계산서 발행", path: "/Supplier/SalesTax/", disabled: true },
    ],
  },

  {
    text: "통계",
    icon: "fa fa-bar-chart text-primary",
    items: [
      {
        text: "견적요청 대비 견적실적",
        path: "/Statistics/QuotationPerformance/",
        disabled: true,
      },
      {
        text: "발주금액집계",
        path: "/Statistics/OrderAmount/",
        disabled: true,
      },
      {
        text: "발주 단가분석 보고서",
        path: "/Statistics/OrderAnalysis/",
        disabled: true,
      },
      { text: "매출현황", path: "/Statistics/SaleStatus/", disabled: true },
      { text: "매출집계", path: "/Statistics/SaleTotal/", disabled: true },
    ],
    visible: false,
  },

  {
    text: "코드관리",
    icon: "fa fa-qrcode text-primary",
    items: [
      { text: "거래처", path: "/Code/Client/" },
      { text: "공통코드", path: "/Code/CommonCode/" },
      { text: "품목코드", path: "/Code/ProductCode/" },
      { text: "선박코드", path: "/Code/ShipCode/" },
    ],
  },

  /*   {
    text: "시스템관리",
    icon: "fa fa-sliders text-primary",
    items: [
      { text: "용어사전", path: "/Sys/DictionaryMgnt/" },
      { text: "메뉴관리", path: "/Sys/MenuMgnt/" },
      { text: "권한관리", path: "/Sys/RoleMgnt/" },
    ],
  }, */
];
